import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const NAMES = ['Lucía', 'Martina', 'Sofía', 'Valentina', 'Camila', 'Julieta', 'Paula', 'Micaela', 'Florencia', 'Agustina', 'Mariana', 'Carolina', 'Daniela', 'Gabriela', 'Victoria'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Bariloche'];
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      triggerNotification();
    }, 5000);
    // Loop
    const interval = setInterval(() => {
      triggerNotification();
    }, 25000 + Math.random() * 10000); // Random interval between 25-35s
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const triggerNotification = () => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    setData({
      name: randomName,
      city: randomCity
    });
    setVisible(true);
    // Hide after 5 seconds
    setTimeout(() => {
      setVisible(false);
    }, 5000);
  };
  return <AnimatePresence data-id="element-1">
      {visible && <motion.div initial={{
      x: -100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-4 left-4 z-50 bg-white/95 backdrop-blur-sm border-l-4 border-pink-500 shadow-lg rounded-r-lg p-4 max-w-xs flex items-center gap-3" data-id="element-2">
          <div className="bg-green-100 p-2 rounded-full" data-id="element-3">
            <CheckCircle className="w-5 h-5 text-green-600" data-id="element-4" />
          </div>
          <div data-id="element-5">
            <p className="text-sm font-bold text-gray-800" data-id="element-6">{data.name}</p>
            <p className="text-xs text-gray-600" data-id="element-7">
              de {data.city} compró la guía
            </p>
            <p className="text-xs text-pink-500 font-medium mt-0.5" data-id="element-8">
              Hace unos instantes
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}